//in milliseconds
const interval = 10000;
const interval_print = 10000;

export default interval;
export { interval_print };
